<template>
	<router-view></router-view>
</template>

<script>
	export default {
		//props:['MenuList'],
		data() {
			return {}
			}
			}
</script>

<style>
</style>
